import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Eyebrow } from "@/components/site/primitives";
import { IMAGES } from "@/i18n";

export const About = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section id="about" ref={ref} className="relative py-28 sm:py-36" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal className="order-2 lg:order-1">
          <div className="relative max-w-md">
            <div className="overflow-hidden rounded-[28px_28px_180px_180px] border border-gold/25 shadow-[0_30px_80px_-25px_rgba(0,0,0,0.7)]">
              <motion.img
                src={IMAGES.aboutPortrait}
                alt="Monia"
                style={{ y }}
                className="w-full h-[560px] object-cover object-center scale-110"
                data-testid="about-portrait"
              />
            </div>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <Eyebrow>{t.about.eyebrow}</Eyebrow>
            <h2 className="mt-5 font-display font-light text-sand text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-7 space-y-4 max-w-xl">
              {t.about.paragraphs.map((p, i) => (
                <p key={i} className="text-sand/75 text-base sm:text-lg leading-relaxed font-light">{p}</p>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
